import { render, staticRenderFns } from "./ip-with-frequent-events.vue?vue&type=template&id=07d91c98&"
import script from "./ip-with-frequent-events.vue?vue&type=script&lang=ts&"
export * from "./ip-with-frequent-events.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports